<template>
  <div class="grid gap-4 w-full max-w-3xl mx-auto">
    <div class="flex flex-col-reverse gap-1">
      <h2 class="text-sm">{{ $t('pages.start.posts.heading') }}</h2>
      <div class="font-heading font-medium text-2xl">{{ $t('pages.start.posts.label') }}</div>
    </div>
    <div class="grid gap-2">
      <div v-for="post in data?.posts" :key="post.id">
        <NuxtLink :to="post.path" class="flex items-center gap-3 bg-mist rounded overflow-hidden">
          <div class="w-16 min-w-16 rounded-l overflow-hidden aspect-square">
            <AtomImage class="object-cover" :src="post.image?.src?.medium" :alt="post.image?.alt || post?.title" />
          </div>
          <div class="grid gap-0.5 pr-2">
            <h3 class="font-bold leading-5 line-clamp-1">{{ post.title }}</h3>
            <p class="text-xs text-[#888] line-clamp-1">{{ post.excerpt }}</p>
          </div>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script async setup>
// Fetch posts
const { data } = await useFetch('/posts', {
  key: `posts-startpage`,
  baseURL: useEnv('cmsBase'),
  query: {
    limit: 100,
    category: 'guider',
    tag: 'cornerstone',
    orderby: 'modified'
  }
})
</script>
